import React, { createContext } from 'react';
import './DashboradSideBar.scss';
import movieDb from '../../assets/movieDB.svg';

const SideBarContext = createContext();
const SideBarConsumer = SideBarContext.Consumer;
const SideBarProvider = SideBarContext.Provider;

export const SideBarTab = ({ isActive, isDisabled, onSelect, children }) => {
  return (
    <div className="dashboradSideBar-main">
      <h4
        className={
          isActive
            ? 'dashboradSideBar-main__title active-bar'
            : 'dashboradSideBar-main__title'
        }
        onClick={isDisabled ? null : onSelect}>
        {children}
      </h4>
    </div>
  );
};

export const SideBariTabList = ({ children }) => {
  return (
    <SideBarConsumer>
      {context => {
        const { activeIndex } = context;
        const sideBariTabListChildren = React.Children.map(
          children,
          (child, index) => {
            return React.cloneElement(child, {
              isActive: index === activeIndex,
              onSelect: () => context.onSelectTab(index)
            });
          }
        );
        return <>{sideBariTabListChildren}</>;
      }}
    </SideBarConsumer>
  );
};

const DashboardSidebar = ({ children, activeIndex, selectTabIndex }) => {
  const getContext = () => {
    return {
      activeIndex: activeIndex,
      onSelectTab: selectTabIndex
    };
  };

  return (
    <SideBarProvider value={getContext()}>
      <div className="dashboradSideBar">
        <div className="dashboradSideBar-poweredBy">
          <a
            href="https://www.themoviedb.org/documentation/api"
            className="dashboradSideBar-poweredBy__link">
            <img
              src={movieDb}
              alt=""
              className="dashboradSideBar-poweredBy__link-img"
            />
          </a>
        </div>
        {children}
      </div>
    </SideBarProvider>
  );
};

export default DashboardSidebar;
